export default "__VITE_ASSET__ea36e2be__"